import { BRAND_NAME } from '../constants'

const DELIMITER = '|'

export const pageTitle = (title?: string) => {
  return [title, BRAND_NAME].filter(Boolean).join(` ${DELIMITER} `)
}
